// ── Slide row layout ──────────────────────────────────────────────────────────
export const SLIDE_NODE_WIDTH = 280;
export const SLIDE_NODE_HEIGHT = 190;
export const SLIDE_GAP = 120;

// ── Question node layout ──────────────────────────────────────────────────────
export const QUESTION_NODE_WIDTH = 220;
export const QUESTION_GAP = 20;
export const QUESTION_HEADER_HEIGHT = 72;
export const ANSWER_ROW_HEIGHT = 34;
export const VERTICAL_GAP = 80;

// ── Action node initial placement (relative to its source question column) ───
export const ACTION_NODE_X_OFFSET = 360;
export const ACTION_NODE_Y_BASE = 320;
export const ACTION_NODE_Y_STEP = 140;
